import * as React from 'react';
import { Image } from '@cian/ui-kit/image';
import { Layout } from '../../../Layout';
import { SlideInformation } from '../../../../containers/SlideInformation';
import { IBanner } from '../../../../types/banners';
import * as styles from './Slide.css';
import { Marquee } from '../../../Marquee';

interface ICarouselBannerProps {
  banner: IBanner;
}

export function Slide(props: ICarouselBannerProps) {
  const { banner } = props;

  if (!banner.imageUrl) {
    return null;
  }

  return (
    <div className={styles['slide']} data-testid="main-carousel-slide">
      <div className={styles['slide__image-wrapper']}>
        <Image src={banner.imageUrl} alt={banner.title || ''} width="100%" height="100%" objectFit="cover" />
      </div>

      <div className={styles['information-container']}>
        <Layout>
          <div className={styles['information__wrapper']}>
            <SlideInformation
              title={banner.title}
              label={banner.label}
              url={banner.publicUrl}
              hasCommercialProperty={banner.hasCommercialProperty}
            />
            {banner.disclaimer && (
              <div data-testid="main-carousel-disclaimer" className={styles['disclaimer']}>
                <Marquee text={banner.disclaimer} />
              </div>
            )}
          </div>
        </Layout>
      </div>
    </div>
  );
}
